import { Injectable } from '@angular/core';

/**
 * Holds the user whose dashboard is currently being viewed when a user other than the logged in user is
 * selected in the dashboard's user filter. The id is sent to the API by {@link DashboardImpersonationInterceptor},
 * which is what makes the dashboard endpoints return their figures as that user would see them. The API only
 * honors it for users whose loans the logged in user can access, and rejects the request otherwise.
 */
@Injectable({ providedIn: 'root' })
export class DashboardImpersonationService {
  private _impersonatedUserId: string | null = null;

  get impersonatedUserId(): string | null {
    return this._impersonatedUserId;
  }

  setImpersonatedUser = (userCompanyGuid: string | null) => {
    this._impersonatedUserId = userCompanyGuid || null;
  };

  /** The user the dashboard figures currently belong to - the selected user when one is selected, the logged in user otherwise. */
  getEffectiveUserId = (loggedInUserCompanyGuid: string): string => {
    return this._impersonatedUserId ?? loggedInUserCompanyGuid;
  };
}
